// eslint-disable-next-line import/prefer-default-export
export const DEFAULT_MAX_AGE = 15 * 60; // 15 mins

export const PUBLIC_NEAREST_GROUP_MAX_AGE = 0; // don't cache the nearest group pages
